var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('p',{staticClass:"sm-spinner",class:{
      'global': _vm.isGlobal || _vm.popupOpen
    }},[_c('lottie',{attrs:{"options":_vm.options,"height":100,"width":100},on:{"animCreated":_vm.handleAnimation}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }